import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "frozen-banner" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = _resolveDirective("i18n");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
            _createTextVNode("The judge froze the game. Nobody can act until the judge unfreezes it.", -1)
        ]))])), [
        [_directive_i18n]
    ]);
}
